import { render, staticRenderFns } from "./timeControl.vue?vue&type=template&id=6bd6b36c&scoped=true&"
import script from "./timeControl.vue?vue&type=script&lang=js&"
export * from "./timeControl.vue?vue&type=script&lang=js&"
import style0 from "./timeControl.vue?vue&type=style&index=0&id=6bd6b36c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd6b36c",
  null
  
)

export default component.exports